import { UserAgentString, DeviceType } from '@amzn/ring-site-user-agent';

export default function isWebView() {
  const parsedUA = UserAgentString.parse(navigator.userAgent);
  return parsedUA.getDetected().software.isWebView || false;
}

/**
 * Check if we are rendered as a WebView inside the Ring App (iOS or Android).
 *
 * `DeviceType` is the enum exported by `@amzn/ring-site-user-agent` (imported
 * above, see its `src/user-agent-string.d.ts`); `dtRingApp` is its `'RingApp'`
 * member. The library assigns it in `detectRingApps()` for both the modern
 * `RingApp/<apiVersion>` UA token and the legacy `ring-android-wv` one.
 *
 * `isWebView()` is deliberately broader — it is also true for a plain Android
 * system WebView. `dtRingApp` is set only by that Ring App detection, which
 * also forces `isWebView` true, so this one term is both necessary and
 * sufficient. Deliberately not also matching on `os.name`: the Ring App only
 * ships on iOS and Android, and an OS check would just add false negatives (an
 * iPod touch reports no OS name, and the iOS app running on an Apple-silicon
 * Mac reports 'Mac OS X').
 */
export const isRingAppWebView = () => UserAgentString.parse(navigator.userAgent).getDetected().device.devType === DeviceType.dtRingApp;

/**
 * Check if the device is a mobile device (phone)
 */
export const isMobileDevice = () => {
  const parsedUA = UserAgentString.parse(navigator.userAgent);
  const deviceType = parsedUA.getDetected().device.devType;
  
  // we consider anything not on desktop/tv/tablet to be mobile, or anything rendered with webview.
  const isMobile = deviceType &&
    deviceType !== DeviceType.dtDesktop &&
    deviceType !== DeviceType.dtTV &&
    deviceType !== DeviceType.dtTablet;

  return isMobile || isWebView();
};
